import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PurchaseOrder, SearchCriteria, CountingDocument } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PurchaseOrderService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    search(tenantId: string, branchId: string, criteria: SearchCriteria): Observable<PurchaseOrder[]> {
        return this.http.post<PurchaseOrder[]>(this.serviceUtils.getBaseUrl('purchaseOrder', tenantId, branchId) + `/search`, criteria);
    }

    searchByKeyword(
        tenantId: string,
        branchId: string,
        keyword: string,
        status: 'active' | 'completed' | 'pendingApproval' | 'all',
        criteria: SearchCriteria,
        showLoading = true,
    ): Observable<PurchaseOrder[]> {
        //TODO: Refactor status handling to use dynamic criterias based on each federation
        //For now, we only have basic status handling for TM federation
        if (status === 'active' || status === 'completed') {
            criteria.items.push({
                condition: 'and',
                name: 'statusId',
                operator: status === 'completed' ? '=' : '<>',
                value: '2',
            });
        } else if (status === 'pendingApproval') {
            criteria.items.push({
                condition: 'and',
                name: 'countingDocument.submittedDate',
                operator: '<>',
                value: null,
            });
            criteria.items.push({
                condition: 'and',
                name: 'countingDocument.approvalDate',
                operator: '=',
                value: null,
            });
        }

        return this.http.post<PurchaseOrder[]>(
            this.serviceUtils.getBaseUrl('purchaseOrder', tenantId, branchId) + `/search/keyword/${encodeURIComponent(keyword)}`,
            criteria,
            {
                headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
            },
        );
    }

    get(tenantId: string, branchId: string, id: string): Observable<PurchaseOrder> {
        return this.http.get<PurchaseOrder>(this.serviceUtils.getBaseUrl('purchaseOrder', tenantId, branchId) + `/${id}`);
    }

    complete(tenantId: string, branchId: string, id: string): Observable<PurchaseOrder> {
        return this.http.put<PurchaseOrder>(this.serviceUtils.getBaseUrl('purchaseOrder', tenantId, branchId) + `/complete/${id}`, {});
    }

    assignCountingDocument(
        tenantId: string,
        branchId: string,
        purchaseOrderId: string,
        countingDocument: CountingDocument,
    ): Observable<PurchaseOrder> {
        return this.http.put<PurchaseOrder>(
            this.serviceUtils.getBaseUrl('purchaseOrder', tenantId, branchId) + `/assign-counting-document/${purchaseOrderId}`,
            countingDocument,
        );
    }
}
